import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import TextFieldStandardized from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import DateFieldStandardized from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import moment from 'moment/moment';
import { defaultFormat } from 'Consts/DateFormats';

export const OnboardingCapacityOverride = buildFacetDesignOverride()
  .nameOverride('capacity', {
    _component: () => TextFieldStandardized,
    _customHelperProps: {
      showRequiredHelperText: false,
    },
    _customProps: {
      InputProps: {
        inputComponent: undefined,
      },
      helperText: '',
    },
  }, overrideReadOnly)
  .nameOverride(['startDate', 'endDate'], {
    _component: () => DateFieldStandardized,
    _customHelperProps: {
      showRequiredHelperText: false,
    },
    _customProps: {
      format: 'MM/DD/YYYY',
      helperText: '',
    },
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment.utc(v).format(defaultFormat);
    },
  }, overrideReadOnly);
